import type { AnyAction } from 'redux';
import { useNavigate, useSearchParams } from '@ksyos/router';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import type { IEmployment } from '../../interfaces/employment';
import { receiveLogin } from '../../../store/authentication/actions';
import { useAbortableFetch } from '../../../utils/hooks/useAbortableFetch';
import { Loader } from '../../elements/common';
import { SelectEmployment } from './SelectEmployment';

export function SsoSelectEmployment() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const abortableFetch = useAbortableFetch();
    const [employments, setEmployments] = useState<IEmployment[]>();
    const dispatch = useDispatch();

    useEffect(() => {
        loadEmployments();
    }, []);

    return employments === undefined ? (
        <Loader
            centered
            large
        />
    ) : (
        <SelectEmployment
            employments={employments}
            selectEmployment={selectEmployment}
        />
    );

    async function loadEmployments() {
        const result = await abortableFetch.fetchJson('/api/user/employments', 'GET');
        setEmployments(result.json.items);
    }

    async function selectEmployment(employmentId: string) {
        const url = `/api/session/sso/${searchParams.get('ssoDataId')}/employment/${employmentId}`;
        const result = await abortableFetch.fetchJson(url, 'GET');
        dispatch(receiveLogin(result.json.user) as unknown as AnyAction);
        navigate(result.json.redirectUrl);
    }
}
